const FCA_USER_COMPANY_ID = 'ffffffff-ffff-ffff-ffff-ffffffffffff';
const COGNITO_USER_LABEL = '11111111-1111-1111-1111-111111111111';
const COGNITO_WORKER_LABEL = '22222222-2222-2222-2222-222222222222';
const COGNITO_OSR_LABEL = '33333333-3333-3333-3333-333333333333';
const COGNITO_ADMIN_LABEL = '44444444-4444-4444-4444-444444444444';
const GOV_ID_TYPE_OTHER_OPTION_ID = '5b9e7141-da81-47b2-8d93-68b749923162';

const piiFields = [
  'dateOfBirth',
  'socialSecurityNumber',
  'line1',
  'line2',
  'city',
  'state',
  'zipCode',
  'country',
  'county',
  'borough',
];

const PRIVACY_POLICY_URL = 'https://fieldcontrolanalytics.com/privacy-policy/';
const CONTACT_US_URL = 'https://fieldcontrolanalytics.com/contact-us/';

//* Logout awaits the session delete before signing out of Cognito, and RequestApi has
//* no default timeout — without a bound, a stalled request hangs logout behind the
//* loader with the user still authenticated.
const DELETE_SESSION_TIMEOUT_MS = 5000;
// Backend column limit for worker first / middle / last name.
const WORKER_NAME_MAX_LENGTH = 255;
// Consent agreement document selection (registration consent wizard steps).
// `kind` filters the pre-fetched agreements; `type` matches the specific document.
export enum ConsentAgreementType {
  TermsAndConditions = 1,
  ProjectConsent = 2,
  BiometricConsent = 3,
}

export enum ConsentAgreementKind {
  Custom = 1,
  Standard = 2,
}

export {
  FCA_USER_COMPANY_ID,
  COGNITO_WORKER_LABEL,
  GOV_ID_TYPE_OTHER_OPTION_ID,
  piiFields,
  PRIVACY_POLICY_URL,
  CONTACT_US_URL,
  COGNITO_USER_LABEL,
  COGNITO_OSR_LABEL,
  COGNITO_ADMIN_LABEL,
  DELETE_SESSION_TIMEOUT_MS,
  WORKER_NAME_MAX_LENGTH,
};
